export default "__VITE_ASSET__BqmEacNA__"